/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CircularContent } from '../../models/circular-content';

export interface ApiMasterCircularContentGetActiveGet$Params {
}

export function apiMasterCircularContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterCircularContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CircularContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCircularContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CircularContent>>;
    })
  );
}

apiMasterCircularContentGetActiveGet.PATH = '/api/Master/CircularContent/GetActive';
